/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downgradenotavailable2Inputs */

const en_downgradenotavailable2 = /** @type {(inputs: Downgradenotavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downgrade not available`)
};

const de_downgradenotavailable2 = /** @type {(inputs: Downgradenotavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downgrade nicht verfügbar`)
};

/**
* | output |
* | --- |
* | "Downgrade not available" |
*
* @param {Downgradenotavailable2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downgradenotavailable2 = /** @type {((inputs?: Downgradenotavailable2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downgradenotavailable2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downgradenotavailable2(inputs)
	return de_downgradenotavailable2(inputs)
});
export { downgradenotavailable2 as "downgradeNotAvailable" }